import script from "./TmSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./TmSelect.vue?vue&type=script&setup=true&lang=js"

import "./TmSelect.vue?vue&type=style&index=0&id=48e804cb&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48e804cb"]])

export default __exports__